import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class SavedCartService {
  maxSavedCartErrorNotification = new BehaviorSubject(false)
}
